import React from "react";

import "./Brand.scss";

export default function Brand() {
  return (
    <div className="brand">
      <p>
        J<span>I</span>NADA
      </p>
    </div>
  );
}
